module.exports = __webpack_public_path__ + "img/es-frbr.e4485b39.svg";